import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import StackGrid from "react-stack-grid";
import Waypoint from "react-waypoint";
import sizeMe from "react-sizeme";
import { Link } from "react-router-dom";
import profileImage from "./img/profile_image.jpg";

import * as THREE from "three";
import Container3d from "react-container-3d";

import img0 from "./img/thumb/cards_ui.png";

import icon_bg from "./svg/icon_bg.svg";
import icon_bg1 from "./svg/icon_bg1.svg";

import icon0 from "./svg/icon0.svg";
import icon1 from "./svg/icon1.svg";
import icon2 from "./svg/icon2.svg";
import icon3 from "./svg/icon3.svg";
import icon4 from "./svg/icon4.svg";
import icon5 from "./svg/icon5.svg";
import icon6 from "./svg/icon6.svg";
import icon7 from "./svg/icon7.svg";

import ProjectsViewer from "./3d/ProjectsViewer";
import {} from "./style/home.css";

import cassiano_logo from "./svg/cassiano.svg";

import Modal from "./Modal";

class Home extends Component {
  constructor(props) {
    super(props);
    this.resize = this.resize.bind(this);
  
    this.state = {
      width: window.innerWidth,
      modalOpen: false
    };
    window.addEventListener("resize", this.resize);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

  }
  componentDidMount() {}

  openModal(received){
    console.log("Modal", received);
    this.setState({
      modalOpen:true,
      selectedProject: received
    })
  }

  closeModal(){
    this.setState({
      modalOpen:false,
      selectedProject: null
    })
  }

  resize() {
    this.setState({ width: window.innerWidth });
  }

  setup = (scene, camera, renderer) => {
    var geometry = new THREE.BoxGeometry(1, 20, 1);
    var material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    var cube = new THREE.Mesh(geometry, material);
    scene.add(cube);
  };

  update(scene, camera, renderer) {

  }

  render() {
    let { width } = this.state;
    let gridSize = "25%";
    let spacing = 30;

    if (width <= 1024) {
      gridSize = "50%";
      spacing = 0;
    }

    if (width <= 800) {
      gridSize = "100%";
      spacing = 0;
    }
    let modalOpen = this.state.modalOpen;
    let classBlur = modalOpen? "pre-blur blur" : "pre-blur";
    
    return (
      <div className="App">
      <div className={classBlur}>
      <ProjectsViewer openModal={this.openModal} />
        <header className="header">
          <div className="title">
            <img src={cassiano_logo} className="title-name"/>
            <div className="title-role">
              <div className="title-role-line"/>
              <div className="title-role-text">
              {"creative prototype developer."}
                </div>
            </div>
            <div className="subtitle"> 
            <a href="http://media.mit.edu">MIT</a> -
              Masters in Media, Arts and Science, 2018
            </div>
            <div className="subtitle">
            <a href="http://ufrn.br">UFRN </a> -
              Science and Technology, 2016
            </div>
          </div>
          <div className="menus">
            <div className="line"/>
            <a className="btn-menu" href="https://github.com/lucascassiano/lucascassiano.github.io/raw/master/resume.pdf">
              RESUME
            </a>
            <a href="http://github.com/lucascassiano" className="btn-menu">
              Github
            </a>
            <a className="btn-menu" href="https://www.linkedin.com/in/lucas-cassiano-a1356313b/">
              Linkedin
            </a>
          </div>
        </header>
        <div className="divider" />
        <div className="contact"><a>C O N T A C T</a><div className="line"/></div>
        </div>
        <Modal isOpen={this.state.modalOpen} project={this.state.selectedProject} onClose={this.closeModal}/>
      </div>
    );
  }
}

export default sizeMe()(Home);



// WEBPACK FOOTER //
// ./src/Home.js